import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Paper from 'material-ui/Paper';
import { Grid, Row, Col } from 'react-flexbox-grid';
import ErrorIcon from 'material-ui/svg-icons/alert/error-outline';
import { white } from 'material-ui/styles/colors'

const errorIconStyle = {
    verticalAlign: 'middle',
    paddingBottom: '3px'
}

const paperErrorStyle = {
    margin: '0px',
    padding: '10px',
    verticalAlign: 'middle',
    color: 'white',
    backgroundColor: 'salmon'
}

const ErrorBox = ({open, text}) => {
    if (open) 
        return <ReactCSSTransitionGroup 
            transitionName="errorAnim" 
            transitionAppear={true} 
            transitionEnterTimeout={10000}
            >
            <Paper 
                style={paperErrorStyle} 
                zDepth={2}>
                <Row>
                    <Col xs={12}>
                        <ErrorIcon 
                            style={errorIconStyle} 
                            color={white} 
                        /> 
                        <span>{text}</span>
                    </Col>
                </Row>
            </Paper>
        </ReactCSSTransitionGroup>;
    else 
        return null;
};

export default ErrorBox;


// WEBPACK FOOTER //
// ./src/components/common/ErrorBox.js